import React, { useEffect, useState, useRef } from "react";
import { TextField, } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import QuotationCommentContainer from "../modals/QuotationCommentContainer";
import axios from "axios";
import { format } from "date-fns";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import CreditCustomerList from "../components/common/CreditCustomerList";
import Modal from "../components/common/CommonModal";
import CashCustomerList from "../components/salesInvoice/CashCustomerList";
import RegisterWalkinCustomerForm from "../components/salesInvoice/RegisterWalkinCustomer";

import useApi from "../hooks/useApi";

const SalesTab = ({
  mode = "quotation", // "quotation" or "salesOrder"
  selectedLead,
  customerType,
  onCustomerTypeChange,
  productsInQuotationState,
  vat,
  setVat,
  callApisAgainInQuoteLead,
  giveNextActionArrayToParent,
  // Quotation mode  props
  setTypedAccountFromChild,
  typedAccountFromChild,
  setTypedCustomerNameFromChild,
  typedCustomerNameFromChild,
  setTypedProjectNameFromChild,
  typedProjectNameFromChild,
  // Sales Order mode  props
  lpoNoState,
  setLpoNoState,
  projectname,
  setprojectname,
  setSelectedCustomerObject,
  selectedCustomerObject,
  salespersonList,
  setTypedSalesPersonId,
  typedSalesPersonId,
  coordinatorList,
  setTypedCoordinatorId,
  typedCoordinatorId,
  handleAddRow,
  fetchCashCustomerList,
  setCashCustomerList,
  cashCustomerList,
  setShowDropdown,
  showDropdown,

  setTypedEmailForQuotationFromChild,
  typedEmailForQuotationFromChild,
  setTypedMobileForQuotationFromChild,
  typedMobileForQuotationFromChild,
  settingDataGotFromQuotationDetailsApiToScreen
}) => {
  
  const [currentSelectedPrevRevisionNumber, setCurrentSelectedPrevRevisionNumber] = useState("-")
  const [previousRevNumberList, setPreviousRevNumberList] = useState(null)
  const [clickedOnPreviousRevisionList, setClickedOnPreviousRevisionList] = useState(false)
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const CURRENT_SELECTED_DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const CURRENT_USER = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : null;
  const projectInputRef = useRef(null);
  const coordinatorInputRef = useRef(null);
  const salespersonInputRef = useRef(null);

  const { request: requestSaveCustomer } = useApi();

  const { request: requestAccountData } = useApi();

  const [areaCodes, setAreaCodes] = useState([]);
  const [showAddNewCustomerPopup, setShowAddNewCustomerPopup] = useState(false);
  const [f2CustomerSearch, setF2CustomerSearch] = useState(false);
  const [f2CustomerSearchCashCustomer, setF2CustomerSearchCashCustomer] =
    useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [userDepartment, setUserDepartment] = useState(null);
  const [organizationList, setOrganizationList] = useState([]);

  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [commentState, setCommentState] = useState("");
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [openSubmitSnackbarFailure, setOpenSubmitSnackbarFailure] =
    useState(false);
  const [fullHistoryOfStatusChange, setFullHistoryOfStatusChange] =
    useState(null);
  const [nextActionArray, setNextActionArray] = useState(null);
  const [nextActionSelectedByUser, setNextActionSelectedByUser] =
    useState(null);

  // Only initialize for quotation mode
  useEffect(() => {
    if (mode === "quotation") {
      const currentDepartmentFromLocalStorage = CURRENT_SELECTED_DEPARTMENT;
      setUserDepartment(currentDepartmentFromLocalStorage);
    }
  }, [mode]);

  console.log(
    `productsInQuotationState in ${mode} mode selectedLeadxxxxxx test`,
    productsInQuotationState,
    selectedLead,
  );

  useEffect(() => {
    if (!selectedLead) {
      onCustomerTypeChange("registered");
    }
  }, []); // only on mount — safest option

  if (mode === "salesOrder") {
    console.log(
      "project name > sale tab customer_name_from_sales_order_details ",
      projectname,
      productsInQuotationState,
    );
  }

  const fetchOrganizationList = async (value) => {
    if (!value || value.length < 1 || mode !== "quotation") {
      return;
    }

    try {
      let url = `${API_PATHS[0].API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${userDepartment}/CUSTOMERS/-/${value}`;

      const response = await axios.get(url);
      setOrganizationList(response.data);
    } catch (error) {
      console.log("Error fetching organization details:", error);
    }
  };

  const handleChangeCustomerName = (event) => {
    if (mode === "quotation") {
      setTypedCustomerNameFromChild(event.target.value);
      setTypedAccountFromChild("00000000");
      setSelectedCustomerObject("");

      setSearchTerm(event.target.value); // This makes the input responsive
    }
  };

  useEffect(() => {
    // If the search term is too short, don't call the API
    if (searchTerm.length === 0) {
      setOrganizationList([]);
      return;
    }

    const delayDebounceFn = setTimeout(() => {
      console.log("Calling Search API for:", searchTerm);
      if (customerType === "registered") {
        fetchOrganizationList(searchTerm);
      } else {
        fetchCashCustomerList(searchTerm);
      }
    }, 500); // 500ms delay

    return () => clearTimeout(delayDebounceFn); // Cleanup the timer on every keystroke
  }, [searchTerm]);

  const handleChangeProjectName = (event) => {
    if (mode === "quotation") {
      setTypedProjectNameFromChild(event.target.value);
    }
  };

  const handleChangeEmail = (event) => {
    if (mode === "quotation") {
      setTypedEmailForQuotationFromChild(event.target.value);
    }
  };

  const handleChangePhonenumber = (event) => {
    if (mode === "quotation") {
      setTypedMobileForQuotationFromChild(event.target.value);
    }
  };

  const handleChange = (event) => {
    const newCustomerType = event.target.value;
    console.log("newCustomerType ", newCustomerType);

    onCustomerTypeChange(newCustomerType);

    setSelectedCustomerObject("");

    if (mode === "quotation") {
      setTypedCustomerNameFromChild("");
      setTypedAccountFromChild("00000000");
    }
  };

  const handleChangeSalesPerson = (event) => {
    const newSalesPerson = event.target.value;
    console.log("newSalesPerson ", newSalesPerson);

    setTypedSalesPersonId(newSalesPerson);
  };

  const handleChangeCoordinator = (event) => {
    const newCoordinator = event.target.value;
    console.log("newCoordinator ", newCoordinator);

    setTypedCoordinatorId(newCoordinator);
  };

  const handleNextActionSelection = (event) => {
    setNextActionSelectedByUser(event.target.value);
  };

  const handleVATChange = (event) => {
    console.log(
      `event.target.value handleVATChange ${mode}`,
      event.target.value,
    );
    setVat(event.target.value);
  };

  const handleComment = (e) => {
    setCommentState(e.target.value);
  };



  const initialdefaultVatApplied = () => {
    setVat(vat);
  };

  useEffect(() => {
    console.log(`vat ${mode}`, vat);
  }, [vat, mode]);

  useEffect(() => {
    if (nextActionArray) {
      giveNextActionArrayToParent(nextActionArray);
    }
  }, [nextActionArray]);

  useEffect(() => {
    initialdefaultVatApplied();
  }, []);

  const callApiToGetNextActionList = (receivedProductInQuotationState) => {
    console.log(
      "receivedProductInQuotationState ",
      receivedProductInQuotationState,
    );

    let compcode = COMPANY_CODE;
    let apiMode =
      mode === "quotation" ? "PROPOSALSTATUSOPTIONS" : "SOSTATUSOPTIONS";
    let task_owner_id = receivedProductInQuotationState
      ? receivedProductInQuotationState[0].area_code !== ""
        ? receivedProductInQuotationState[0].area_code
        : "Draft"
      : "-";
    let task_id = "-";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${apiMode}/${task_owner_id}/${task_id}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setNextActionArray(res.data);
      })
      .catch((err) => { });
  };

  const callApiToGetFullHistoryOfStatusChange = (
    receivedProductInQuotationState,
  ) => {
    console.log(
      `callApiToGetFullHistoryOfStatusChange ${mode} `,
      receivedProductInQuotationState,
      selectedLead,
    );

    // Add null check for selectedLead
    if (!selectedLead) {
      console.log("selectedLead is undefined, skipping API call");
      return;
    }

    const currentUserfromLocalStorage = localStorage.getItem("currentUser");

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
    }


    let compcode = COMPANY_CODE;
    let apiMode = mode === "quotation" ? "PROPOSALTIMELINE" : "SOTIMELINE";
    let task_owner_id =
      mode === "quotation"
        ? selectedLead?.deptno || userDepartment || "-" // Use fallback values
        : selectedLead?.deptno ||
        productsInQuotationState?.[0]?.dept_from_so_details ||
        userDepartment ||
        "-";
    let task_id = productsInQuotationState
      ? productsInQuotationState[0]?.quotation_number + ""
      : "NEW";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${apiMode}/${task_owner_id}/${task_id}`;

    console.log("apiurl >> status change", apiUrl);
    axios
      .get(apiUrl)
      .then((res) => {
        setFullHistoryOfStatusChange(res.data);
      })
      .catch((err) => {
        console.error("Error fetching status change history:", err);
      });
  };

  const callAPIToChangeStatus = (comment) => {
    console.log(
      `productsInQuotationState >> selectedLead>> callAPIToChangeStatus ${mode}`,
      productsInQuotationState,
      selectedLead,
    );

    // Add null check for selectedLead
    if (!selectedLead && mode === "quotation") {
      console.log(
        "selectedLead is undefined for quotation mode, cannot change status",
      );
      alert("Cannot change status: Lead information is missing");
      return;
    }

    const currentUserfromLocalStorage = CURRENT_USER;
    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    }

    const jsonObject = [
      {
        CmpCode: COMPANY_CODE,
        mode: mode === "quotation" ? "PROPOSAL" : "SALESORDER",
        DocNo: productsInQuotationState
          ? productsInQuotationState[0]?.quotation_number + ""
          : "NEW",
        deptno:
          mode === "quotation"
            ? selectedLead?.deptno || userDepartment || "-" // Use fallback values
            : selectedLead?.deptno ||
            productsInQuotationState?.[0]?.dept_from_so_details ||
            userDepartment ||
            "-",
        Status: nextActionSelectedByUser?.trim
          ? nextActionSelectedByUser?.trim()
          : nextActionSelectedByUser,
        Comments: comment,
        UserID: currentUserEMPID?.trim(),
        created_on: format(new Date(), "yyyy-MM-dd"),
      },
    ];

    const jsonToSend = JSON.stringify(jsonObject);
    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/ProposalStatus`;

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.result === "Saved") {
          setOpenSubmitSnackbar(true);
          setCommentState("");
          // Only call this if selectedLead exists
          // because of this checking no refresh happened in futture check this conditon needed or not
          // if (selectedLead?.Prop_No) {
          callApisAgainInQuoteLead(selectedLead.Prop_No);
          // }
        } else {
          setOpenSubmitSnackbarFailure(true);
        }
      })
      .catch((err) => {
        console.error("Error changing status:", err);
        setOpenSubmitSnackbarFailure(true);
      });
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setOpenSubmitSnackbarFailure(false);
  };

  useEffect(() => {
    if (productsInQuotationState) {
      if (productsInQuotationState[0]) {
        if (mode === "salesOrder") {
          console.log(
            "productsInQuotationState[0].so_ref",
            productsInQuotationState[0].so_ref,
          );
          setLpoNoState(
            productsInQuotationState[0].so_ref
              ? productsInQuotationState[0].so_ref
              : "",
          );
        }

        callApiToGetNextActionList(productsInQuotationState);
        callApiToGetFullHistoryOfStatusChange(productsInQuotationState);

        callAPIToGetPreviousRev()
      }

      if (mode === "quotation") {
        console.log(
          "customer type after productsInQuotationState ",
          productsInQuotationState[0],
          typeof productsInQuotationState[0]?.customer_account_from_details,
        );

        // Set customer type
        if (productsInQuotationState[0]?.customer_account_from_details) {
          if (
            productsInQuotationState[0]?.customer_account_from_details ==
            "00000000"
          ) {
            onCustomerTypeChange("walkin");
          } else {
            onCustomerTypeChange("registered");
          }
        }

        if (productsInQuotationState[0]?.customer_name_from_details) {
          setTypedCustomerNameFromChild(
            productsInQuotationState[0]?.customer_name_from_details,
          );
        }

        if (productsInQuotationState[0]?.customer_account_from_details) {
          setTypedAccountFromChild(
            productsInQuotationState[0]?.customer_account_from_details,
          );
        }

        if (productsInQuotationState[0]?.project_name_from_details) {
          setTypedProjectNameFromChild(
            productsInQuotationState[0]?.project_name_from_details,
          );
        }

        if (productsInQuotationState[0]?.customer_email_from_details) {
          setTypedEmailForQuotationFromChild(
            productsInQuotationState[0]?.customer_email_from_details,
          );
        }

        if (productsInQuotationState[0]?.customer_phone_from_details) {
          setTypedMobileForQuotationFromChild(
            productsInQuotationState[0]?.customer_phone_from_details,
          );
        }
      }
    }
  }, [productsInQuotationState, mode]);

  const handleInputLPO = (e) => {
    if (mode === "salesOrder") {
      setLpoNoState(e.target.value);
    }
  };

  const handleKeyUp = (e) => {
    console.log(
      "Key pressed: customertype--->",
      e.key,
      "altKey:-->",
      e.altKey,
      "code:",
      e.code,
      customerType,
    );

    // F2 handler
    if (e.key === "F2") {
      console.log("F2 pressed");
      if (e.target.name === "organization") {
        if (customerType === "registered") {
          setOrganizationList([]);
          setShowDropdown(false);
          setF2CustomerSearch(true);
        } else {
          setCashCustomerList([]);
          setShowDropdown(false);
          setF2CustomerSearchCashCustomer(true);
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keyup", handleKeyUp);

    // Cleanup function - IMPORTANT!
    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [customerType]);

  useEffect(() => {
    const currentUserObject = CURRENT_USER;
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const selectCustomerOrganization = (customer) => {
    if (mode === "quotation") {
      setTypedAccountFromChild(customer.account?.trim());
      setTypedCustomerNameFromChild(customer.Custname?.trim());
      setSelectedCustomerObject(customer); // this is not using anywhere i think
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint = `${API_PATHS[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/AREALIST/-/-`;
        const response = await requestAccountData({
          url: endpoint,
          method: "GET",
          timeout: 10000,
        });
        setAreaCodes(response);
      } catch (error) {
        console.error("Error fetching Area codes:", error);
      }
    };
    fetchData();
  }, []);

  const renderQuotationFields = () => (
    <div className="flex gap-4 ">
      <div className="w-full">
        <div className="flex lg:flex-row flex-col gap-2 w-full">
          {console.log(
            "typedCustomerNameFromChild >>>",
            typedCustomerNameFromChild,
          )}
          <div className="lg:mb-0 mb-2   relative w-1/2">
            <TextField
              // sx={{ minWidth: "350px" }}
              sx={{ width: "100%" }}
              label="Customer/Organization"
              value={
                typedCustomerNameFromChild ? typedCustomerNameFromChild : ""
              }
              name="organization"
              size="small"
              variant="standard"
              onChange={(e) => {
                handleChangeCustomerName(e);
                setShowDropdown(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  // Focus first item in dropdown
                  if (customerType === "registered") {
                    document.querySelector("[data-dropdown-item]")?.focus();
                  } else {
                    document
                      .querySelector("[data-dropdown-item-walkin]")
                      ?.focus();
                  }
                }
              }}
              autoComplete="off"
            />

            {organizationList &&
              customerType === "registered" &&
              showDropdown &&
              typedCustomerNameFromChild?.length > 0 && (
                <div className="absolute top-15 left-0 w-full bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-10 border border-gray-300">
                  {console.log("organizationList:", organizationList)}
                  {organizationList.map((organization, index) => (
                    <div
                      data-dropdown-item
                      tabIndex={0}
                      onClick={() => {
                        let customerObjectToPass = {
                          account: organization.ACCOUNT,
                          Custname: organization.DESCRIPTION,
                          AutoId:0
                        };

                        selectCustomerOrganization(customerObjectToPass);
                        setShowDropdown(false);
                        setTimeout(() => projectInputRef.current?.focus(), 0);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          let customerObjectToPass = {
                            account: organization.ACCOUNT,
                            Custname: organization.DESCRIPTION,
                            AutoId:0
                          };
                          selectCustomerOrganization(customerObjectToPass);
                          setShowDropdown(false);
                          setTimeout(() => projectInputRef.current?.focus(), 0);
                        } else if (e.key === "ArrowDown") {
                          e.preventDefault();
                          e.currentTarget.nextElementSibling?.focus();
                        } else if (e.key === "ArrowUp") {
                          e.preventDefault();
                          e.currentTarget.previousElementSibling?.focus();
                        }
                      }}
                      key={index}
                      className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                    >
                      <p className="font-normal text-sm flex items-start justify-between w-full">
                        {organization.DESCRIPTION}{" "}
                        <span className="font-normal text-sm bg-blue-500 text-white px-3 py-1 rounded-full">
                          {organization.ACCOUNT}
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              )}

            {cashCustomerList &&
              customerType === "walkin" &&
              showDropdown &&
              typedCustomerNameFromChild?.length > 0 && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-10 border border-gray-300">
                  {console.log("cash customer:", cashCustomerList)}
                  {cashCustomerList.map((cashCustomerObject, index) => (
                    <div
                      data-dropdown-item-walkin
                      tabIndex={0}
                      onClick={() => {
                        let customerObjectToPass = {
                          account: "00000000",
                          Custname: cashCustomerObject.DESCRIPTION,
                          AutoId: cashCustomerObject.AutoId,
                        };
                        selectCustomerOrganization(customerObjectToPass);
                        setShowDropdown(false);
                        setTimeout(() => projectInputRef.current?.focus(), 0);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          let customerObjectToPass = {
                            account: "00000000",
                            Custname: cashCustomerObject.DESCRIPTION,
                            AutoId: cashCustomerObject.AutoId,
                          };
                          selectCustomerOrganization(customerObjectToPass);
                          setShowDropdown(false);
                          setTimeout(() => projectInputRef.current?.focus(), 0);
                        } else if (e.key === "ArrowDown") {
                          e.preventDefault();
                          e.currentTarget.nextElementSibling?.focus();
                        } else if (e.key === "ArrowUp") {
                          e.preventDefault();
                          e.currentTarget.previousElementSibling?.focus();
                        }
                      }}
                      key={index}
                      className="px-1 py-0.5 border bg-white hover:bg-gray-200 flex justify-between items-start"
                    >
                      <p className="font-normal">
                        {cashCustomerObject.DESCRIPTION}
                      </p>
                      <span className="font-normal bg-blue-500 text-white p-2">
                        {cashCustomerObject.AutoId}
                      </span>
                    </div>
                  ))}
                </div>
              )}

            {typedCustomerNameFromChild?.length > 0 &&
              cashCustomerList?.length === 0 &&
              customerType === "walkin" &&
              showDropdown && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-10 border border-gray-300">
                  <button
                    className="m-2 p-1 bg-blue-500 text-white"
                    onClick={() => setShowAddNewCustomerPopup(true)}
                  >
                    {" "}
                    + Add New Customer
                  </button>
                </div>
              )}
          </div>
          <div>
            <p className="font-light text-[#00000099] text-xs">
              Customer Account
            </p>
            <span>{typedAccountFromChild}</span>
          </div>

          <div>
            <p className="font-light text-[#00000099] text-xs">AutoId</p>
            <span>
              {selectedCustomerObject?.AutoId
                ? selectedCustomerObject?.AutoId
                : "-"}
            </span>
          </div>
        </div>

        <div className="mt-2 mb-2 flex">
          <TextField
            sx={{ width: "50%" }}
            label="Project"
            value={typedProjectNameFromChild}
            variant="standard"
            onChange={(e) => {
              handleChangeProjectName(e);
            }}
            autoComplete="off"
            inputRef={projectInputRef}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setTimeout(() => coordinatorInputRef.current?.focus(), 0); // ✅ ADD
              }
            }}
          />

          {/* <TextField
            select
            label="Coordinator"
            name="coordinator"
            value={typedCoordinatorId ?? ""}
            style={{ marginLeft: 10 }}
            onChange={(e) => {
              handleChangeCoordinator(e); // existing handler
              // After coordinator selected, move to salesperson
              setTimeout(() => salespersonInputRef.current?.focus(), 0); // ✅
            }}
            fullWidth
            variant="standard"
            id="coordinator"
            inputRef={coordinatorInputRef}
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif",
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important",
              },
            }}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Coordinator
            </MenuItem>

            {coordinatorList?.map((item) => {
              return (
                <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>
              );
            })}
          </TextField> */}

          <TextField
            select
            label="Coordinator"
            name="coordinator"
            value={typedCoordinatorId ?? ""}
            // ...from here added
            displayEmpty
            slotProps={{
              inputLabel: { shrink: true },
              select: {
                displayEmpty: true,
                renderValue: (value) => {
                  if (value === "" || value === null || value === undefined) {
                    return "GENERAL";
                  }
                  return (
                    coordinatorList?.find(
                      (item) => item.EMP_ID?.trim() === value
                    )?.NAME || value
                  );
                },
              },
            }}
            // ...addition ends here
            style={{ marginLeft: 10 }}
            onChange={(e) => {
              handleChangeCoordinator(e); // existing handler
              // After coordinator selected, move to salesperson
              setTimeout(() => salespersonInputRef.current?.focus(), 0); // ✅
            }}
            fullWidth
            variant="standard"
            id="coordinator"
            inputRef={coordinatorInputRef}
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif",
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important",
              },
            }}

          >
            <MenuItem value="">GENERAL</MenuItem>
            {coordinatorList
              ?.filter((item) => item.EMP_ID?.trim() !== "")
              .map((item) => (
                <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>
              ))}
          </TextField>

          <TextField
            select
            label="Sales Person"
            name="salesperson"
            value={typedSalesPersonId}
            style={{ marginLeft: 10 }}
            onChange={(e) => {
              handleChangeSalesPerson(e); // existing
              setTimeout(() => handleAddRow(e), 0); // ✅ ADD
            }}
            fullWidth
            required
            variant="standard"
            id="salesperson"
            inputRef={salespersonInputRef}
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif",
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important",
              },
            }}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Sales Person
            </MenuItem>

            {salespersonList?.map((item) => {
              return (
                <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>
              );
            })}
          </TextField>


         

        </div>
      </div>
    </div>
  );

  const renderSalesOrderFields = () => (
    <>
      <div className="flex gap-4">
        <div>
          <p className="font-light text-[#00000099] text-xs">
            Customer/Organization
          </p>
          <span>
            {productsInQuotationState &&
              productsInQuotationState[0]
                ?.customer_name_from_sales_order_details}
          </span>
        </div>

        <div>
          <p className="font-light text-[#00000099] text-xs">
            Customer Account
          </p>
          <span>
            {productsInQuotationState &&
              productsInQuotationState[0]
                ?.customer_account_from_sales_order_details}
          </span>
        </div>
      </div>

      <div>
        <TextField
          label="Enter LPO No"
          value={lpoNoState}
          size="small"
          variant="standard"
          onChange={(e) => handleInputLPO(e)}
        />
      </div>

      <div>
        <TextField
          label="Enter project name"
          value={projectname}
          size="small"
          variant="standard"
          onChange={(e) => setprojectname(e.target.value)}
        />
      </div>
    </>
  );

  const renderTopInfoRow = () => {
    if (mode === "quotation") {
      return (
        <div className="flex flex-wrap gap-4" style={{ width: "100%" }}>
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Lead ID</span>
            <span>{selectedLead?.lead_id || "NEW"}</span>
          </p>
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Stage</span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.area_code !== ""
                  ? productsInQuotationState[0]?.area_code
                  : "Draft"
                : "Draft"}
            </span>
          </p>

          <div>
            <FormControl sx={{ minWidth: "140px" }} variant="standard">
              <InputLabel>Next Action</InputLabel>
              <Select
                value={nextActionSelectedByUser}
                onChange={handleNextActionSelection}
              >
                {nextActionArray?.map((item) => (
                  <MenuItem key={item.new_status} value={item.new_status}>
                    {item.new_status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>QO No</span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.quotation_number
                : "NEW"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Rev No</span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.revision_number
                : "0"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column", position: "relative" }}>
            {" "}
            <span style={{ color: "#000000", backgroundColor: "#d7d7d7", paddingLeft: "10px", paddingRight: "10px", paddingTop: "2px", paddingBottom: "2px" }} onClick={() => setClickedOnPreviousRevisionList(prev => !prev)}>View Previous Rev{" "}</span>
            <span style={{ position: "absolute", zIndex: 3,overflowY: "scroll",
    maxHeight: "200px", backgroundColor: "#f7f7f7", borderWidth: "1px", top: "30px", padding: "2px", width: "100%" }}>
              {(previousRevNumberList && clickedOnPreviousRevisionList)
                ?  previousRevNumberList.length > 0 ?  previousRevNumberList.map((item) => {
                  return (

                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                      <button onClick={() =>  clickedOnPrevRevision(item.Rev_No) } style={{ backgroundColor: "#d7d7d7", padding: "2px", marginTop: "2px" }}>{item.Rev_No}</button>
                      {item.Rev_No == currentSelectedPrevRevisionNumber &&
                        <button onClick={() => { callApiToGetPreviousRevisionDetails(item.Rev_No); setClickedOnPreviousRevisionList(false) }} style={{ backgroundColor: "#000000",color:"#ffffff", padding: "2px", marginBottom: "10px" }}>Confirm and transfer details</button>
                      }
                    </div>
                  )
                }) : <p>No previous revision</p>
                :
                currentSelectedPrevRevisionNumber
              }
            </span>
          </p>
          
        </div>
      );
    } else {
      return (
        <div className="flex flex-wrap gap-4" style={{ width: "100%" }}>
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Stage</span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.area_code !== ""
                  ? productsInQuotationState[0]?.area_code
                  : "Draft"
                : "Draft"}
            </span>
          </p>

          <div>
            <FormControl sx={{ minWidth: "140px" }} variant="standard">
              <InputLabel>Next Action</InputLabel>
              <Select
                value={nextActionSelectedByUser}
                onChange={handleNextActionSelection}
              >
                {nextActionArray?.map((item) => (
                  <MenuItem key={item.new_status} value={item.new_status}>
                    {item.new_status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Sales Order No</span>
            <span>
              {selectedLead?.so_no || selectedLead?.Salesorder_No || "NEW"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Qtn No</span>
            <span>
              {selectedLead?.qtn_no ||
                selectedLead?.Prop_No ||
                selectedLead?.Proposal_No ||
                "NEW"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Lead ID</span>
            <span>{selectedLead?.Lead_ID || "NEW"}</span>
          </p>
        </div>
      );
    }
  };

  const handleCustomerSelect = async (customer) => {
    console.log("customer", customer);

    let customerObjectToPass = {
      account: customer.ACCOUNT,
      Custname: customer.DESCRIPTION,
    };

    selectCustomerOrganization(customerObjectToPass);
    setF2CustomerSearch((prev) => !prev);
  };

  const handleCustomerSelectCashCustomer = async (customer) => {
    console.log("cash customer", customer);

    let customerObjectToPass = {
      account: "00000000",
      Custname: customer.DESCRIPTION,
      AutoId: customer.AutoId,
    };

    selectCustomerOrganization(customerObjectToPass);
    setF2CustomerSearchCashCustomer((prev) => !prev);
  };

  const handleSaveCustomer = async (customerData) => {
    console.log("OnSave", customerData);
    try {
      const url = `${API_PATHS[0].API_CONFIG}/api/CRMAcmastCRM`;
      const response = await requestSaveCustomer({
        url: url,
        method: "POST",
        data: customerData,
        config: {
          headers: {
            "Content-Type": "application/json",
          },
        },
        timeout: 5000,
      });

      console.log("Customer Saved Sucessfully", response);
      setShowAddNewCustomerPopup(false);
      if (typedCustomerNameFromChild) {
        fetchCashCustomerList(typedCustomerNameFromChild);
      }
    } catch (error) {
      console.error(
        "Upload Error:",
        error.response ? error.response.data : error.message,
      );
    }
  };

  const callAPIToGetPreviousRev = () => {

    axios.get(`${API_PATHS[0].API_CONFIG}/api/Search_Itemsnew/${COMPANY_CODE}/QuoteRevList/${productsInQuotationState[0]?.quotation_number}/${CURRENT_SELECTED_DEPARTMENT}`).then((res) => {

      if (res.data) {
        setPreviousRevNumberList(res.data)
      }
    }).catch((err) => {
      console.log("err", err)
    })
  }

  const clickedOnPrevRevision = (rev_number) => {

    setCurrentSelectedPrevRevisionNumber(rev_number)

  }

  const callApiToGetPreviousRevisionDetails = (rev_number) => {

    let url = `${API_PATHS[0].API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/QuoteDetailsRev/-/-/${rev_number}/${productsInQuotationState[0]?.quotation_number}/${CURRENT_SELECTED_DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`

    console.log("revision details  url", url)

    axios.get(url).then((res) => {

      if (res.data) {
        console.log("revision details ", res.data)

        if(res.data.length > 0){

          console.log("revision details in SalesTab", res.data)
          settingDataGotFromQuotationDetailsApiToScreen(res)
         
        }
      }

    }).catch((err) => {
      console.log("err", err)
    })

  }

  return (
    <div className=" flex lg:flex-row flex-col justify-end">
      <div className="lg:w-[60%] w-fullflex flex-col justify-between items-left gap-4 lg:mb-0 mb-3">
        {renderTopInfoRow()}

        <div className="flex justify-left items-center lg:gap-8 gap-3">
          {mode === "quotation" && (
            <div>
              <FormControl component="fieldset">
                <FormLabel component="legend">Customer Type</FormLabel>
                <RadioGroup row value={customerType} onChange={handleChange}>
                  <FormControlLabel
                    value="registered"
                    control={<Radio />}
                    label="Registered Customer"
                  />
                  <FormControlLabel
                    value="walkin"
                    control={<Radio />}
                    label="Walk-in"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          )}

          <div className="lg:w-40 w-full">
            <FormControl fullWidth variant="standard">
              <InputLabel>VAT Category</InputLabel>
              <Select value={vat} onChange={handleVATChange}>
                <MenuItem value="noVat">0% (No VAT)</MenuItem>
                <MenuItem value="vatApplied">VAT Applied</MenuItem>
                <MenuItem value="vatExempted">VAT Exempted</MenuItem>
                <MenuItem value="outOfScope">Out of Scope</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        {mode === "quotation"
          ? renderQuotationFields()
          : renderSalesOrderFields()}


<TextField
            sx={{ width: "50%" }}
            label="Email"
            value={typedEmailForQuotationFromChild}
            variant="standard"
            onChange={(e) => {
              handleChangeEmail(e);
            }}
            autoComplete="off"
            // inputRef={projectInputRef}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     e.preventDefault();
            //     setTimeout(() => coordinatorInputRef.current?.focus(), 0); // ✅ ADD
            //   }
            // }}
          />
          <TextField
            sx={{ width: "50%" }}
            label="Phone"
            value={typedMobileForQuotationFromChild}
            variant="standard"
            onChange={(e) => {
              handleChangePhonenumber(e);
            }}
            autoComplete="off"
            // inputRef={projectInputRef}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     e.preventDefault();
            //     setTimeout(() => coordinatorInputRef.current?.focus(), 0); // ✅ ADD
            //   }
            // }}
          />
      </div>

      <div className=" lg:w-[40%] w-full">
        {productsInQuotationState &&
          productsInQuotationState[0]?.quotation_number !== "" && (
            <QuotationCommentContainer
              callAPIToChangeStatus={callAPIToChangeStatus}
              fullHistoryOfStatusChange={fullHistoryOfStatusChange}
              productsInQuotationState={productsInQuotationState}
              nextActionSelectedByUser={nextActionSelectedByUser}
              handleComment={handleComment}
              commentState={commentState}
              setCommentState={setCommentState}
              setNextActionSelectedByUser={setNextActionSelectedByUser}
            />
          )}
      </div>

      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="success" sx={{ width: "100%" }}>
          Successfully Saved!
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSubmitSnackbarFailure}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="error" sx={{ width: "100%" }}>
          Something went wrong, Please try later
        </MuiAlert>
      </Snackbar>

      {/*Common Modal */}
      <Modal
        isOpen={f2CustomerSearch}
        onClose={() => setF2CustomerSearch((prev) => !prev)}
        title="Select Customer"
        size="xxl"
        header={true}
      >
        <CreditCustomerList
          handleCustomerSelect={handleCustomerSelect}
          defaultType="Customers"
        />
      </Modal>

      <Modal
        isOpen={f2CustomerSearchCashCustomer}
        onClose={() => setF2CustomerSearchCashCustomer((prev) => !prev)}
        title="Select Cash Customer"
        size="xxl"
        header={true}
      >
        <CashCustomerList
          handleCustomerSelect={handleCustomerSelectCashCustomer}
        />
      </Modal>

      <Modal
        isOpen={showAddNewCustomerPopup}
        onClose={() => setShowAddNewCustomerPopup((prev) => !prev)}
        header={false}
        size="xxl"
      >
        <RegisterWalkinCustomerForm
          onSave={handleSaveCustomer}
          onCancel={() => {
            setShowAddNewCustomerPopup(false);
          }}
          areaCodes={areaCodes}
          customer={typedCustomerNameFromChild}
        />
      </Modal>
    </div>
  );
};

export default SalesTab;
